import queryString from 'query-string';
import StorageService from 'services/StorageService'
import parse from 'html-react-parser';

let slugify = (str) =>{
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    let from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    let to   = "aaaaeeeeiiiioooouuuunc------";
    for (let i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
};

const HtmlParse = (text) => {
    if(typeof text !== 'string') return text;
    return parse(text);
}

const cleanSearch = (search) => {
    if(typeof search !== 'string') return search;
    const characters = /\.|'|`|"|°|_|@|!|\?|¿|¡|&|\+|,|:|;|%/g;

    search = search.replace(characters, "").replace('(', '').replace(')', '');

    let from = "àáäâèéëêìíïîòóöôùúüûñç";
    let to   = "aaaaeeeeiiiioooouuuunc";
    for (let i=0, l=from.length ; i<l ; i++) {
        search = search.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    return search;
};


const cleanAddress = (search) => {

    if (typeof search !== 'string') return search;
    const characters = /\.|'|\$|"|°|_|@|!|\?|¿|¡|&|\+|:|;|<|>|#|%|/g;
    search = search.replace(characters, "").replace(/\r?\n|\r/g, '').replace(/\\/g, '');

    return search;
}


const cleanFacet = (search) => {
    if(typeof search !== 'string') return search;
    const characters = /\.|'|`|"|°|_|@|!|\?|¿|¡|&|\+|,|:|;|%/g;

    search = search.replace(characters, "-").replace('(', '').replace(')', '');

    let from = "àáäâèéëêìíïîòóöôùúüûñç";
    let to   = "aaaaeeeeiiiioooouuuunc";
    for (let i=0, l=from.length ; i<l ; i++) {
        search = search.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    return search;
};

let isEquivalent = (a, b) => {
    // Create arrays of property names
    let aProps = Object.getOwnPropertyNames(a);
    let bProps = Object.getOwnPropertyNames(b);

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length != bProps.length) {
        return false;
    }

    for (let i = 0; i < aProps.length; i++) {
        let propName = aProps[i];

        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
            return false;
        }
    }

    // If we made it this far, objects
    // are considered equivalent
    return true;
};

const loadScript = function(src, callback) {
    const element = document.querySelector('[src*="'+ src +'"');
    if(element && element[0]) return false;
    const tag = document.createElement('script');
    tag.async = false;
    tag.src = src;
    if(callback){
        tag.addEventListener('load', callback);
    }
    document.getElementsByTagName('body')[0].appendChild(tag);
};

const elipsis = function(string, size) {
    return (string.length > size) ? (string.substring(0, size - 3) + '...') : string;
};

const hasClass = (ele,cls) => {
    return ele && !!(ele.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)')));
};

const addClass = (element, newClass) => {
    if(!element) return false;
    if(element.classList && element.classList.add){
        element.classList.add(newClass);
    } else if ( (' '+element.className+' ').indexOf(' '+newClass+' ') < 0 ) {
        element.className += ' ' + newClass;
    }
};

const removeClass = (element, className) => {
    if(!element) return false;
    if(element.classList && element.classList.remove) {
        element.classList.remove(className);
    } else {
        const reg = new RegExp('(^| )'+className+'($| )','g');
        element.className = element.className.replace(reg,' ');
    }
};

const replaceClass = (element, oldClass, newClass) => {
    if(!element) return false;
    removeClass(element, oldClass);
    addClass(element, newClass);
};

const hexToRgbA = function(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ','+opacity+')';
    }
    return '';
};

const getLinkCategory = (link) => {
    if(link.indexOf('.com.br') !== -1 || link.indexOf('.com') !== -1){
        return (link.indexOf('.com.br') !== -1 ? link.split('.com.br')[1] : link.split('.com')[1]);
    } else {
        return link;
    }
};

const fixUrlCategory = (url) => {
    if (!url) return '';
    url = getLinkCategory(url);
    url = url.split('?')[0];
    if(typeof window !== 'undefined' && window.location && window.location.search){
        let search = queryString.parse(window.location.search);
        if(search.page){
            search.page = 1;
        }
        search = queryString.stringify(search);
        url  = url + '?' + search;
    }
    return url.replace('---', '-').replace("á", "a").replace("é", "e").replace("í", "i").replace("ó", "o").replace("ú", "u").replace("ñ", "n");
}

const cloneArray = (array) => {
    return array.concat([]).map(item => {
        return {...item};
    });
};

const createTab = () => {
    let tabs = StorageService.getItem('change_tabs');

    if(!tabs || tabs === 'null') {
        tabs = {};
    } else {
        tabs = JSON.parse(tabs);
    }

    const tabId = new Date().getTime();

    tabs[tabId] = false;
    StorageService.setItem('change_tabs', JSON.stringify(tabs));

    return tabId;
}

const updateTabs = () => {
    let tabs = StorageService.getItem('change_tabs');

    if(typeof window !== 'undefined' && tabs && tabs[0]) {
        tabs = JSON.parse(tabs);

        const tabId= JSON.stringify(window.tabId);

        for(let key in tabs){

            if(key !== tabId) {
                tabs[key] = true;
            }
        }

        StorageService.setItem('change_tabs', JSON.stringify(tabs));
    }
}

const removeTab = () => {
    let tabs = StorageService.getItem('change_tabs');
    tabs = JSON.parse(tabs);

    if(typeof window !== 'undefined' && tabs){
        delete tabs[window.tabId];
    }

    StorageService.setItem('change_tabs', JSON.stringify(tabs));
}

const updateTabChange = () => {
    let tabs = StorageService.getItem('change_tabs');
    tabs = JSON.parse(tabs);

    if(typeof window !== 'undefined' && tabs && (tabs[window.tabId] === true)){
        tabs[window.tabId] = false;

        StorageService.setItem('change_tabs', JSON.stringify(tabs));
        window.location.reload();
    }
}
const isBotNavigation = () => {
    if(!(typeof navigator !== 'undefined' && navigator.userAgent)) return true;
    return /bot|google|crawler|spider|robot|crawling/i.test(navigator.userAgent);
}

const removeEmojis = (txt) => {
    return txt.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
}

export {
    slugify,
    isEquivalent,
    loadScript,
    elipsis,
    addClass,
    removeClass,
    replaceClass,
    hasClass,
    hexToRgbA,
    cloneArray,
    cleanSearch,
    cleanFacet,
    getLinkCategory,
    fixUrlCategory,
    updateTabs,
    createTab,
    removeTab,
    updateTabChange,
    isBotNavigation,
    removeEmojis,
    HtmlParse,
    cleanAddress
}
